import React,{Component} from 'react';
import "./index.less";
import {ListView,Icon} from "antd-mobile";
import {connect} from "react-redux";
// import {poolColor,poolStatus} from '../../common/js/carPoolCommon';
// import {pickColor,pickStatus} from '../../common/js/pickCommon';
const head =  require('../../common/image/user.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ShiftList extends Component{
    constructor(props) {
        console.log(props)
        super(props);
       
    };
    render(){
        const _renderRow = (i, index, rowID) => (
               
            <div className="list" key={rowID} onClick={()=> this.props.goPage(i.id,'progressDetail')}>
                <div className="status">
                    <div className="head">
                        <img className="image" src={head} />
                        <div className="carNum">
                            <span>{i.driverName}</span>
                        </div>
                        <div className="vichcleName">{i.carModelName}</div>
                    </div>
                    <div className="orderNum">
                        <span><span className="site">接站</span><span className="orderBg">订单号：{i.orderNum}</span></span>
                        { /* <span style={{color:`${pickColor(i.status)}`}}>{pickStatus(i.status)}</span> */}
                    </div>
                    <div className="content">
                        <div className="date"><span>{i.estimatedTimeOfDeparture}</span></div>
                        <div className="location"><span><i className="icon iconfont iconchufadi"></i></span>{i.startAddress}</div>
                        <div className="location"><span><i className="icon iconfont iconmudedi"></i></span>{i.endAddress}</div>
{/*                         <div className="grade"><span>{i.carModelName}</span><span>{i.carSeatNum}座</span><span style={{color:`${pickColor(i.status)}`}}>{pickStatus(i.status)}</span></div>
        */    }                </div>
                </div>
            </div> 
               
            
        )
        return(
            <div className="poolHistory">
                <div className="content">
                    {this.props.notData()}
                    {
                        this.props.notDataLoading === 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.props.dataSource}
                                renderFooter={() => (this.props.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this.props._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/historyComponent/index.js